import styled from 'styled-components';
import { styleVariables } from '../../../common/constants';

const FilterRootElement = styled.div`
    margin-bottom: 4px;
    .accordion-list {
        box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1) inset;
        margin: 0 0 4px 0px;
        border-radius: 4px;
        &.Mui-expanded {
            box-shadow:
                0px 0px 0px 1px rgba(204, 204, 204, 0.5) inset,
                0px -1px 0px 0px #666 inset;
            margin: 0 0 4px 0px;
        }
    }
    .sub-accordion-block{
        box-shadow: none;
        border-radius: 0;
        &.Mui-expanded:first-of-type{
            margin-top:4px;
        }
    }
    .accordion-heading {
        padding: 0;
        .MuiAccordionSummary-content {
            padding: 16px;
            justify-content: space-between;
            text-transform: capitalize;
            .MuiTypography-headline-smaller{
                padding-right:5px;
            }
            svg {
                transform: rotate(0deg);
            }
            &.Mui-expanded {
                svg {
                    transform: rotate(180deg);
                }
            }
        }
        &.sub-accordion-heading{
            .MuiAccordionSummary-content {
                padding: 0;
                justify-content: flex-start;
                text-transform: capitalize;
                gap: 12px;
            }  
            &:hover{
                &::before{
                    background:none;
                }
            }
        }
    }
    .accordion-content {
        padding: 0 16px 30px;
        ul {
            list-style-position: outside;
            line-height: 24px;
            padding-left: 0px;
            li{
                padding-left:15px;
            }
        }
        li{
            padding:0;
            margin-bottom:4px;
            cursor: pointer;
            .MuiCheckbox-root{
                margin-right:12px;
            }
        }
        p {
            color: ${styleVariables.primitivesColor.primary.black};
            a {
                color: ${styleVariables.primitivesColor.primary.black} !important;
            }
        }
        .subAccordion{
            padding-left: 0;
            padding-right: 0;
            &:hover{
                background: none;
            }
            svg{
                margin-right:12px;
            }
        }
    }
    .filter-heading-mobile{
        display:none;
        @media (max-width: 767px) {
            display: flex;
            padding: 16px;
            justify-content: space-between;
            align-items: center;
            position: sticky;
            top: 0;
            z-index: 9;
            background: #fff;
            border-bottom: rgba(0, 0, 0, 0.1) solid 1px;
        }
    }
`;
export default FilterRootElement;
